<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button @click="handleEdit('',0)" type="primary" icon="el-icon-plus">新增</el-button>
    </div>
    <el-table border :data="companyLists" style="width: 100%">
      <el-table-column label="日期" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="code" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态" width="120" align="center">
        <template scope="scope">
          <el-button type="text" v-if="scope.row.status==2" plain>停用</el-button>
          <el-button type="text" v-if="scope.row.status==1" plain>启用</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row,1)">编辑</el-button>
          <el-button
            type="info"
            size="mini"
            @click="blockUp(scope.row)"
            v-if="scope.row.status==1"
          >停用</el-button>
          <el-button
            type="success"
            size="mini"
            @click="startUsing(scope.row)"
            v-if="scope.row.status==2"
          >启用</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item label="code" prop="applicationId" :label-width="formLabelWidth">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">取 消</el-button>
        <el-button type="primary" @click="submitData">确 定</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination 
      @size-change="handleSizeChange" 
      @current-change="handleCurrentChange" 
      :current-page="currentPage" 
      :page-sizes="[10,20,50]" 
      :page-size="pageSize" 
      layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  companyList,
  editcompanyList,
  addcompanyList,
  delcompanyList,
  companyStatus 
} from "@/api/sys/mycompany";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      titleName: "编辑",
      companyLists: [],
      showEditBox: false,
      changeType: 1,
      formLabelWidth: "120px",
      currentPage:1,
      pageSize:10,
      totalSize:0,
      form: {
        code: "",
        id: 0,
        name: ""
      }
    };
  },
  mounted() {
    this.getcompanyList();
  },
  methods: {
    getcompanyList() {
      companyList().then(res => {
        this.companyLists = res.result.list;
      });
    },
    handleEdit(row, type) {
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = row;
        this.titleName = "编辑";
      } else {
        this.titleName = "新增";
      }
      this.showEditBox = true;
    },
    changeStatus(pram) {
      let data = {
        id: pram.id,
        status: pram.status
      };
      companyStatus(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
        }
      });
    },
    startUsing(row) {
      row.status = 1;
      this.changeStatus(row);
    },
    blockUp(row) {
      row.status = 2;
      this.changeStatus(row);
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delcompanyList(row.id).then(res => {
              if (res.code == 0) {
                this.getcompanyList();
              }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    submitData() {
      if (this.changeType == 1) {
        editcompanyList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: "修改成功",
              type: "success"
            });
          }
          this.getcompanyList();
        });
      } else {
        addcompanyList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: "添加成功",
              type: "success"
            });
          }
          this.getcompanyList();
        });
      }

      this.showEditBox = false;
    },
    handleSizeChange(val){
     this.pageSize = val;
     this.getcompanyList()
    },
    handleCurrentChange(val){
      this.currentPage = val;
       this.getcompanyList()
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>